import { render, staticRenderFns } from "./UpdateDialog.vue?vue&type=template&id=2ffe45c8&scoped=true&lang=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=js"
export * from "./UpdateDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateDialog.vue?vue&type=style&index=0&id=2ffe45c8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe45c8",
  null
  
)

export default component.exports